module.exports = __webpack_public_path__ + "static/media/back_hi_card.4e57d59b.jpg";